import React, { useRef, useEffect } from 'react'
import useGetPrice from '../hooks/useGetPrice'
import classNames from 'classnames'

export default function PriceStriked(props) {
    const {
        item,
        product,
        quantity = 1,
        style = {},
        className = '',
        eswPriceStrikedClassname = '',
    } = props

    const { price, baseprice } = useGetPrice(product)
    const price_display = price ? `${price.currency_symbol}${price.price * quantity}` : ''
    const baseprice_display = baseprice ? `${baseprice.currency_symbol}${baseprice.price}` : ''
    
    const elRef = useRef(null)
    useEffect(() => {
        if(!elRef?.current) return
        elRef.current.innerText = price_display || baseprice_display
    }, [elRef, price, item])

    const isOnPromotion = Boolean(price?.promotion_price || baseprice?.promotion_price)
    const hasDiscountApplied = Boolean(parseFloat(item?.discount_applied))
    
    if (isOnPromotion || hasDiscountApplied) {
        return (
            <s
                ref={elRef}
                style={style}
                data-bp-lti={baseprice_display}
                className={classNames(
                    'text-secondary',
                    'fw-semibold',
                    className,
                    eswPriceStrikedClassname,
                )}
            >
            </s>
        )
    }
}
